/**
 * Shared Credentia logo components — use these everywhere instead of
 * one-off image tags so the brand stays consistent.
 *
 * <CredentiaIcon size={32} />                    — icon mark only (nav, small spaces)
 * <CredentiaIcon size={32} variant="dark" />     — navy C for light backgrounds
 * <CredentiaWordmark iconSize={32} />            — icon + "CREDENTIA" text (auth screens, headers)
 *
 * variant="light" (default) — white C on dark background  → /logo-icon-white.png
 * variant="dark"            — navy C on light background  → /logo-icon.png
 */

export function CredentiaIcon({ size = 32, variant = "light" }) {
  const src = variant === "dark" ? "/logo-icon.png" : "/logo-icon-white.png";
  return (
    <img
      src={src}
      width={size}
      height={size}
      alt="Credentia"
      style={{ display: "block", objectFit: "contain" }}
    />
  );
}

export function CredentiaWordmark({ iconSize = 40, variant = "light", style = {} }) {
  return (
    <div style={{ display: "inline-flex", flexDirection: "column", alignItems: "center", gap: 10, ...style }}>
      <CredentiaIcon size={iconSize} variant={variant} />
      <div style={{ textAlign: "center" }}>
        <div style={{
          fontFamily: "'DM Serif Display', Georgia, serif",
          fontSize: Math.round(iconSize * 0.55),
          fontWeight: 700,
          color: "#FFFFFF",
          letterSpacing: "0.12em",
          lineHeight: 1,
          marginBottom: 6,
        }}>
          CREDENTIA
        </div>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 7 }}>
          <span style={{ display: "inline-block", width: 20, height: 1.5, background: "#2FAF9F", borderRadius: 1 }} />
          <span style={{ fontSize: Math.round(iconSize * 0.2), fontWeight: 700, color: "#2FAF9F", letterSpacing: "0.16em", textTransform: "uppercase" }}>
            Turn Evidence Into CESR
          </span>
          <span style={{ display: "inline-block", width: 20, height: 1.5, background: "#2FAF9F", borderRadius: 1 }} />
        </div>
      </div>
    </div>
  );
}
